<button type="button" class="nav-button button icon-button " (click)="onToggleMenu()">
  @if (menuOpen$ | async; as menuOpen) {
    <app-icon name="ic_close"/>
  } @else {
    <app-icon name="ic_main_menu"/>
  }
</button>
